import { GasStation } from '../data/stations'
import { User } from '../types/user'
interface Vehicle {
  id: string
  ticketNumber: string
  name: string
  phone: string
  plateNumber: string
  vehicleType: string
  category: string
  pumpNumber: number
  serviceType: string
  estimatedPrice: number
  addedAt: Date
  status: 'waiting' | 'in-service' | 'completed'
  serviceStartedAt?: Date
  completedAt?: Date
  addedBy: string
  addedByName: string
  lastModifiedBy?: string
  lastModifiedByName?: string
}
interface StatusChangeEvent {
  vehicleId: string
  fromStatus: Vehicle['status']
  toStatus: Vehicle['status']
  timestamp: Date
  stationId: string
  userId: string
  userName: string
}
interface CompletedVehicleRecord {
  plateNumber: string
  completedAt: Date
  stationId: string
  stationName: string
  ticketNumber: string
}
interface DatabaseSchema {
  stations: GasStation[]
  users: User[]
  stationQueues: Record<string, Vehicle[]>
  statusChangeHistory: StatusChangeEvent[]
  completedVehicles: CompletedVehicleRecord[]
  lastUpdated: string
}
const DB_KEY = 'cecogec_queue_database'
// Fonction pour convertir les dates en objets Date lors du chargement
const reviveDates = (key: string, value: any): any => {
  if (typeof value === 'string') {
    // Vérifier si c'est une date ISO
    const datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/
    if (datePattern.test(value)) {
      return new Date(value)
    }
  }
  return value
}
export const saveToDatabase = (data: Partial<DatabaseSchema>): void => {
  try {
    const existingData = loadFromDatabase()
    const updatedData: DatabaseSchema = {
      ...existingData,
      ...data,
      lastUpdated: new Date().toISOString(),
    }
    localStorage.setItem(DB_KEY, JSON.stringify(updatedData))
    console.log('✅ Données sauvegardées avec succès')
  } catch (error) {
    console.error('❌ Erreur lors de la sauvegarde:', error)
  }
}
export const loadFromDatabase = (): DatabaseSchema => {
  try {
    const stored = localStorage.getItem(DB_KEY)
    if (!stored) {
      return {
        stations: [],
        users: [],
        stationQueues: {},
        statusChangeHistory: [],
        completedVehicles: [],
        lastUpdated: new Date().toISOString(),
      }
    }
    const data = JSON.parse(stored, reviveDates)
    console.log('✅ Données chargées avec succès')
    return data
  } catch (error) {
    console.error('❌ Erreur lors du chargement:', error)
    return {
      stations: [],
      users: [],
      stationQueues: {},
      statusChangeHistory: [],
      completedVehicles: [],
      lastUpdated: new Date().toISOString(),
    }
  }
}
export const clearDatabase = (): void => {
  try {
    localStorage.removeItem(DB_KEY)
    console.log('✅ Base de données effacée')
  } catch (error) {
    console.error("❌ Erreur lors de l'effacement:", error)
  }
}
export const exportDatabase = (): string => {
  const data = loadFromDatabase()
  return JSON.stringify(data, null, 2)
}
export const importDatabase = (jsonData: string): boolean => {
  try {
    const data = JSON.parse(jsonData, reviveDates)
    localStorage.setItem(DB_KEY, JSON.stringify(data))
    console.log('✅ Base de données importée avec succès')
    return true
  } catch (error) {
    console.error("❌ Erreur lors de l'importation:", error)
    return false
  }
}
